var render = function render(_c,_vm){return _c('div',_vm._b({class:['product-inshowroom', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id}},'div',_vm.data.attrs,false),[_c('lazy-icon',{attrs:{"icon":"house","variant":"dark"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }